import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import noop from 'lodash/noop';
import { StructureFromNameOptions, StructureFromNameTexts } from '@Pages/StructureEditor/StructureEditorConstants';
import { updateDialog as updateDialogAction } from '@Containers/Dialogs/DialogsActions';
import mapOptions from './utils';
import GSFNButton from './GSFNButton';
import { typeOfGSFNDialog } from './GSFNDialog';

export function GSFNContainer({ openDialog, onStructureLoaded, onButtonClick = noop }) {
  const onClickHandler = () => {
    onButtonClick();
    openDialog({
      options: mapOptions(StructureFromNameOptions),
      notFoundMessage: StructureFromNameTexts.nameNotFoundMessage,
      onStructureLoaded,
    });
  };

  return <GSFNButton onClick={onClickHandler} />;
}

GSFNContainer.propTypes = {
  openDialog: PropTypes.func.isRequired,
  onStructureLoaded: PropTypes.func.isRequired,
  onButtonClick: PropTypes.func,
};

const mapDispatchToProps = {
  openDialog: (dialogProps = {}) =>
    updateDialogAction({
      id: typeOfGSFNDialog,
      dialogType: typeOfGSFNDialog,
      ...dialogProps,
    }),
};

export default connect(null, mapDispatchToProps)(GSFNContainer);
